module.exports = __webpack_public_path__ + "static/media/vegan-icon.d0607cb3.png";